import { Uniform } from 'three'
import { Effect } from 'postprocessing'

import shader from './shader'
import { forwardRef, useMemo } from 'react'

let _uStrength

class VerticalDistortionEffect extends Effect {
  constructor({ strength = 0 } = {}) {
    super('VerticalDistortionEffect', shader.fragmentShader, {
      uniforms: new Map([['strength', new Uniform(strength)]]),
    })

    _uStrength = strength
  }

  /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */

  uniforms(uniformValues) {
    return {
      strength: 0,
      ...uniformValues,
    }
  }

  update(renderer, inputBuffer, deltaTime) {
    // this.uniforms.get('strength').value = this.uniforms().strength
  }
}

const VerticalDistortion = forwardRef(({ strength = 1 }, ref) => {
  const effect = useMemo(() => new VerticalDistortionEffect({ strength }), [strength])
  return (
    <primitive
      ref={ref}
      object={effect}
      dispose={null}
    />
  )
})

export default VerticalDistortion
